import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(
  (theme) => ({
    modal: {
      [theme.breakpoints.up('lg')]: {
        width: '730px',
      },
    },
  }),
  { name: 'ProOrRetailModal' },
);
